import React, { Component } from 'react';
import { func, number } from 'prop-types';
import { connect } from 'react-redux';

import Button from '../common/Button';
import Snackbar from '../common/Snackbar';
import { exportStudentProfile } from '../../actions/reportActions';

class ExportStudentProfile extends Component {
  constructor() {
    super();

    this.state = { submitSuccess: false };

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    const { studentId, exportStudentProfile } = this.props;
    exportStudentProfile(studentId);
    this.setState({ submitSuccess: true });
  }

  render() {
    const { submitSuccess } = this.state;

    return (
      <div>
        <Snackbar
          open={submitSuccess}
          onClose={() => this.setState({ submitSuccess: false })}
          message="La ficha está siendo procesada"
          buttonTitle="IR A REPORTES"
          linkTo="/reportes"
          linkButton
        />
        <Button
          fontSize="1.6em"
          margin="1rem 0"
          padding=".5rem 0"
          width="14rem"
          onClick={this.onSubmit}
        >
          Exportar PDF
        </Button>
      </div>
    );
  }
}

ExportStudentProfile.propTypes = {
  exportStudentProfile: func.isRequired,
  studentId: number
};

const mapDispatch = dispatch => ({
  exportStudentProfile: id => dispatch(exportStudentProfile(id))
});

export default connect(null, mapDispatch)(ExportStudentProfile);



// WEBPACK FOOTER //
// ./src/components/student/ExportStudentProfile.js